import Vue from 'vue';
import VueRouter from 'vue-router'
import HomeRouter from './modules/home/router'
import NewsIARouter from './modules/news-ia/router'

Vue.use(VueRouter)

class Router {

    constructor(){
        const routes = this.loadRoutes();
        this.config = new VueRouter({
            mode: 'history', // Eliminar el # de las URLs
            routes
        })
    }

    loadRoutes(){
        const routes = [
            ...HomeRouter,
            ...NewsIARouter
        ]
        return routes;
    }
}

export default Router;